<!--
 * @Description: 火蓝机电
 * @Author: kecraft
 * @Date: 2024-08-19 10:22:01
 * @LastEditors: kecraft
 * @LastEditTime: 2024-08-26 13:50:05
 * @FilePath: /custom-website-desk/src/views/enterpriseCulture/components/partyWindowNew.vue
-->
<template>
  <div class="frame-work">
    <div v-if="!showDetail" id="frameworkBox">
      <div class="frame-top">
        <div class="top-info">
          <div class="top-left">
            <img src="@/assets/framework/center-icon.png" class="circle-img" />
            <div class="circle-icon icon1">
              <div>党委书记</div>
              <div>主导作用</div>
            </div>
            <div class="circle-icon icon2">
              <div>支部书记</div>
              <div>主导作用</div>
            </div>
            <div class="circle-icon icon3">
              <div>职工群众</div>
              <div>主人作用</div>
            </div>
            <div class="circle-icon icon4">
              <div>党员干部</div>
              <div>主体作用</div>
            </div>
            <div class="circle-icon icon5">
              <div>班子成员</div>
              <div>主体作用</div>
            </div>
            <div class="center-text">
              <div>“五维同频”</div>
              <div>“无畏攻坚”</div>
              <div>“党建品牌”</div>
            </div>
          </div>
          <div class="top-right">
            <div class="big-title">“五维同频 无畏攻坚”</div>
            <div class="normal-text">
              五维同频：依托党委书记、班子成员、支部书记、党员干部、职工群众五大主体，开展五个专项行动，实现党建引领三种赋能，切实把党建优势转化为集团创新优势、竞争优势和发展优势，为推动集团高质量发展提供坚强政治保证力和精神动力。
              无畏攻坚：勇者无畏，攻坚有为。勇者无畏意味着全体机电人要有勇气和决心去面对集团发展遇到的困难和挑战，不屈不挠地追求目标。攻坚有为则强调了全体机电人还需要智慧和策略，找到解决问题的有效途径和方法，展现了机电人勇气、决心、行动和智慧，体现了机电人忠诚担当、用心干事、专心成事的精神。
            </div>
          </div>
        </div>

        <div class="top-scroll">
          <swiper
            :slidesPerView="3"
            :spaceBetween="20"
            :modules="modules"
            class="mySwiper2"
            :loop="true"
            :autoplay="{
              delay: 6000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              hideOnClick: true,
            }"
          >
            <swiper-slide
              class="swiper_box"
              v-for="(item, index) of swiperList"
              :key="index"
            >
              <div class="swiper-title">{{ item.title }}</div>
              <div
                class="swiper-text"
                v-html="normalizeRichText(item.content)"
              ></div>
              <div class="swiper-name">{{ item.unit }}</div>
            </swiper-slide>
          </swiper>

          <div class="swiper-button-next is-right"></div>
          <div class="swiper-button-prev is-left"></div>
        </div>
      </div>

      <div class="framework-bottom">
        <div class="bottom-left">
          <div
            class="bottom-left-item"
            v-for="(item, index) of tabList"
            :key="index"
            @click="changeItem(item)"
            :class="chooseItem === item.id ? 'left-select' : ''"
          >
            <div class="is-line"></div>
            <div class="is-name">{{ item.title }}</div>
          </div>
        </div>
        <div class="bottom-right">
          <div class="card-list">
            <div v-for="(item, index) of list1" class="card-item" :key="index">
              <div class="list-number">{{ dealTime(item.timeline) }}</div>
              <div class="list-time">{{ dealTime1(item.timeline) }}</div>
              <div class="list-title">{{ showTitle }}</div>
              <img
                v-if="item.thumbUrl"
                :src="item.thumbUrl || defaultImg()"
                alt=""
                onerror="this.onerror=null;this.src=defaultImg()"
                class="list-img"
              />
              <img
                v-else-if="showTitle == '党建动态'"
                :src="require(`@/assets/type1-${index + 1}.png`)"
                class="list-img"
              />
              <img
                v-else-if="showTitle == '青年团建'"
                :src="require(`@/assets/type3-${index + 1}.png`)"
                class="list-img"
              />
              <div class="list-content">{{ item.title }}</div>
              <div
                class="list-btn"
                @click="
                  item.link
                    ? turnToPage(item)
                    : turnTo({
                        url: '/enterpriseCulture',
                        query: {
                          id: 2,
                          title: item.title,
                          content: item.id,
                        },
                      })
                "
              >
                查看详情<img src="@/assets/framework/arrow.png" />
              </div>
            </div>
          </div>
          <div class="bottom-list">
            <div
              class="list-item"
              v-for="(item, index) of tableList"
              :key="index"
              @click="
                item.link
                  ? turnToPage(item)
                  : turnTo({
                      url: '/enterpriseCulture',
                      query: {
                        id: 2,
                        title: item.title,
                        content: item.id,
                      },
                    })
              "
            >
              <div class="item-content">{{ item.title }}</div>
              <div class="item-time">{{ item.timeline.split(" ")[0] }}</div>
            </div>

            <div class="page_box">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalValue"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right_article2" v-else>
      <div class="small_title">
        <span @click="backFn">返回</span>
      </div>
      <div class="article_box">
        <div class="title">{{ nowChoose.title }}</div>
        <img
          v-if="nowChoose.thumbUrl"
          :src="nowChoose.thumbUrl || defaultImg()"
          alt=""
          onerror="this.onerror=null;this.src=defaultImg()"
        />
        <div class="article" v-html="normalizeRichText(nowChoose.content)"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
import { Autoplay, Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/swiper.min.css";
import "swiper/modules/navigation.css";
import "swiper/modules/pagination.css";
import "swiper/modules/scrollbar.css";
const modules = [Autoplay, Pagination, Navigation, A11y];
import { ref, reactive, nextTick, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
let totalValue = ref(0);
const showTitle = ref("");
const list1 = ref([]);
const swiperList = ref([]);
let params = reactive({
  pageNo: 1,
  pageSize: 10,
  resourceId: 68,
  classifyId: "",
});
const chooseItem = ref("");
let tabList = ref([]);
let tableList = ref([]);
let showDetail = ref(false);
const nowChoose = ref({});
onMounted(() => {
  getMenu();
  api.qywhListInfo({ resourceId: 109 }).then((res) => {
    if (res.code === "0" && res.res.data) {
      swiperList.value = res.res.data;
    }
  });
  // setWidth();
  // window.addEventListener("resize", () => {
  //   setWidth();
  // });
});

const setWidth = () => {
  const width = window.innerWidth;
  if (width < 1920) {
    const box = document.getElementById("frameworkBox");
    const rate = width / 1920;
    box.style.transformOrigin = "center top";
    box.style.transform = `scaleX(${rate}) scaleY(${rate})`;
  }
};
const backFn = () => {
  showDetail.value = false;
  turnTo({
    url: "/enterpriseCulture",
    query: {
      id: 2,
    },
  });
};

const turnToPage = (item) => {
  window.open(item.link, "_blank");
};
const turnTo = (data) => {
  router.push({
    path: data.url,
    query: data.query,
  });
};
const handleCurrentChange = (val) => {
  params.pageNo = val;
  nextTick(() => {
    getList();
  });
};
const dealTime = (v) => {
  const time = v.split(" ")[0];
  const list = time.split("-");
  let result = list[2];
  return result;
};
const dealTime1 = (v) => {
  const time = v.split(" ")[0];
  const list = time.split("-");
  let result = list[1];
  let year = list[0];
  return result + "/" + year;
};
const changeItem = (item) => {
  chooseItem.value = item.id;
  showTitle.value = item.title;
  nextTick(() => {
    getList();
  });
};

const getMenu = async () => {
  tabList.value = [
    {
      auditFlag: 1,
      id: 5,
      orderIndex: 20,
      resourceId: 123,
      title: "党建动态",
      updatedTime: "2024-06-14 10:04",
    },
    // {
    //   auditFlag: 1,
    //   id: 6,
    //   orderIndex: 19,
    //   resourceId: 123,
    //   title: "工会之家",
    //   updatedTime: "2024-06-14 10:05",
    // },
    {
      auditFlag: 1,
      id: 7,
      orderIndex: 18,
      resourceId: 123,
      title: "青年团建",
      updatedTime: "2024-07-08 16:34",
    },
  ];
  chooseItem.value = tabList.value[0].id;
  showTitle.value = tabList.value[0].title;
  nextTick(() => {
    getList();
  });
};
const getList = async () => {
  params.classifyId = chooseItem.value;
  let res = await api.getArticlePage(params);
  if (res.code === "0") {
    totalValue.value = res.res.data.total;
    if (res.res.data.records && res.res.data.records.length > 3) {
      const list = res.res.data.records.slice(0, 3);
      list1.value = list;
      const listBottom = res.res.data.records.slice(3, totalValue.value - 1);
      tableList.value = listBottom;
    } else {
      const list = res.res.data.records;
      list1.value = list;
      tableList.value = [];
    }
  }
};

watch(
  () => route.query,
  (newValue) => {
    if (newValue && newValue.content && newValue.title) {
      api.getById({ id: newValue.content }).then((res) => {
        if (res.code === "0") {
          const newContent = res.res.data.content.replace(
            /font\-size\:(\s*\d+(?:\.\d+)?)px\s*(\;*)/gi,
            function (_styname, key, key1) {
              console.log(_styname, key, key1);
              return "font-size:" + "16px" + key1;
            }
          );
          nowChoose.value.content = newContent;
          nowChoose.value.title = newValue.title;
          showDetail.value = true;
        }
      });
    }
  },
  { immediate: true, deep: true }
);
</script>

<style lang="less" scoped>
.right_article2 {
  width: calc(100%);
  box-sizing: border-box;
  padding: 40px 160px;

  .small_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    text-align: left;
    font-style: normal;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #999999;
      line-height: 20px;
      font-style: normal;
      cursor: pointer;
    }
  }

  .article_box {
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #333333;
      line-height: 67px;
      font-style: normal;
      text-align: center;
      margin: 35px 0px 42px 0px;
    }

    img {
      width: 100%;
      height: 564px;
    }

    // .article {
    //   font-family: 仿宋_GB2312;
    //   font-weight: 600;
    //   font-size: 16px;
    //   color: #333333;
    //   line-height: 30px;
    //   text-align: left;
    //   font-style: normal;
    //   margin-top: 36px;
    //   padding-bottom: 36px;
    // }

    .detail_list {
      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        text-align: left;
        font-style: normal;
      }
    }
  }
}

.page_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 60px;
  margin-bottom: 70px;
}

.frame-work {
  width: 100%;

  .frame-top {
    width: 100%;
    height: 1426px;
    background: url("~@/assets/framework/top-bg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .circle-img {
      width: 285px;
      position: absolute;
      left: 133px;
      top: 120px;
    }

    .circle-icon {
      width: 130px;
      height: 130px;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0px 0 20px 0px rgba(0, 0, 0, 0.18);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      & > div {
        font-size: 22px;
        color: #333;
        line-height: 28px;
        text-align: center;
        font-weight: bold;
      }
    }

    .icon1 {
      position: absolute;
      left: 215px;
      top: 54px;
    }

    .icon2 {
      position: absolute;
      left: 353px;
      top: 153px;
    }

    .icon3 {
      position: absolute;
      left: 297px;
      top: 317px;
    }

    .icon4 {
      position: absolute;
      left: 116px;
      top: 317px;
    }

    .icon5 {
      position: absolute;
      left: 68px;
      top: 156px;
    }
  }

  .top-info {
    width: 1600px;
    height: 513px;
    background: rgba(255, 255, 255, 0.96);
    box-sizing: border-box;
    margin-top: 116px;
    display: flex;

    .top-left {
      width: 546px;
      height: 513px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .center-text {
        & > div {
          font-size: 24px;
          color: #333;
          line-height: 28px;
          text-align: center;
        }
      }
    }

    .top-right {
      width: 1055px;
      height: 513px;
      background: url("~@/assets/framework/top-right.png") no-repeat;
      background-size: 100% 100%;

      .big-title {
        padding-left: 86px;
        padding-top: 56px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 48px;
        color: #ffffff;
        line-height: 67px;
      }

      .normal-text {
        box-sizing: border-box;
        padding: 27px 79px 27px 107px;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }

  .top-scroll {
    position: relative;
    width: 1600px;
    margin-top: 50px;

    .is-right {
      position: absolute;
      right: -65px;
      width: 54px;
      height: 54px;
      background: url("~@/assets/swiper-arrow.png") no-repeat;
      background-size: 100% 100%;
      transform: rotate(180deg);
    }

    .is-left {
      width: 54px;
      height: 54px;
      background: url("~@/assets/swiper-arrow.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: -65px;
    }
  }

  .swiper_box {
    width: 510px;
    height: 604px;
    background: rgba(255, 255, 255, 0.96);
    box-sizing: border-box;
    padding: 52px 60px 49px 55px;

    .swiper-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 30px;
      color: #333333;
      line-height: 42px;
    }

    .swiper-text {
      font-size: 16px;
      color: #333333;
      line-height: 26px;
      height: 400px;
      margin-bottom: 20px;
      box-sizing: border-box;
      padding-top: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .swiper-name {
      font-size: 20px;
      line-height: 28px;
      color: #333333;
      font-weight: 600;
    }
  }

  .swiper_box:hover {
    background: url("~@/assets/hover-bg.png") no-repeat;
    background-size: 100% 100%;

    div {
      color: #ffffff !important;
    }
  }
}

.framework-bottom {
  margin-top: 90px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  .bottom-left {
    .bottom-left-item {
      display: flex;
      align-items: center;
      margin-bottom: 42px;
      cursor: pointer;

      .is-line {
        width: 31px;
        height: 1px;
        margin-right: 47px;
      }

      .is-name {
        width: 222px;
        font-size: 24px;
        color: #333333;
        line-height: 33px;
      }
    }
  }

  .left-select {
    .is-line {
      background: #c53032;
    }

    .is-name {
      color: #c53032 !important;
    }
  }

  .bottom-right {
    // flex: 1;

    .card-list {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 50px;

      .card-item {
        width: 428px;
        height: 612px;
        border-left: 1px solid #d5d5d5;
        box-sizing: border-box;
        padding: 26px 42px 48px 39px;

        .list-number {
          font-weight: bold;
          font-size: 50px;
          color: #333333;
          line-height: 70px;
        }

        .list-time {
          margin-top: 6px;
          color: #333333;
          font-size: 24px;
          line-height: 33px;
        }

        .list-title {
          color: #333333;
          font-size: 36px;
          line-height: 50px;
          margin-top: 13px;
        }

        .list-img {
          width: 342px;
          height: 209px;
          margin-top: 12px;
        }

        .list-content {
          margin-top: 21px;
          height: 100px;
          font-size: 18px;
          color: #333333;
          line-height: 27px;
        }

        .list-btn {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
            margin-left: 6px;
          }
        }
      }

      .card-item:last-child {
        border-right: 1px solid #d5d5d5;
      }

      .card-item:hover {
        background: #c53032;
        border-color: #c53032;

        div {
          color: #ffffff !important;
        }
      }
    }

    .list-item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(213, 213, 213, 0.47);
      margin-bottom: 23px;

      .item-content {
        font-size: 18px;
        color: #333333;
        line-height: 25px;
      }

      .item-time {
        font-size: 18px;
        color: #9a9a9a;
        line-height: 25px;
        padding-bottom: 6px;
      }
    }
  }
}

.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: "" !important;
}

.swiper-button-prev:after {
  content: "" !important;
}
</style>
